// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__I201i","forgotPassword":"LoginForm_forgotPassword__PTjlQ","register":"LoginForm_register__GcSjQ","subtitle":"LoginForm_subtitle__EQ37E"};